import type { HttpResponse } from '../http/client';

/**
 * Link ヘッダー（RFC 8288）に rel="next" の関係が含まれるかを判定する
 */
export function hasNextLink(linkHeader: string | null | undefined): boolean {
  if (!linkHeader) return false;
  return /;\s*rel="?next"?/.test(linkHeader);
}

/**
 * ページネーションの 1 ページ分。hasNext は Link ヘッダーに rel="next" があるか
 */
export interface Page<T> {
  items: T[];
  hasNext: boolean;
}

/**
 * http.request の結果を Page にする
 */
export function toPage<T>({ data, headers }: HttpResponse<T[]>): Page<T> {
  return { items: data, hasNext: hasNextLink(headers.get('link')) };
}
